var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasUserErrors
      ? _c(
          "div",
          _vm._l(_vm.status.userErrors, function (errors, userError, index) {
            return _c("div", { key: index }, [
              _c("b", [_vm._v(_vm._s(userError))]),
              _vm._v(" "),
              _c(
                "ul",
                { staticStyle: { "list-style-type": "disc" } },
                _vm._l(errors, function (error, indexError) {
                  return _c("li", { key: userError + indexError }, [
                    _vm._v("\n          " + _vm._s(error) + "\n        "),
                  ])
                }),
                0
              ),
            ])
          }),
          0
        )
      : _c("div", [_vm._v(_vm._s(_vm.genericMessage))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }